import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { Typography } from 'cprime-foundational-components';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { generateTestId, scrollTo } from 'utils/general';

const LinkToSectionScroll = ({ label, scrollToId }) => {
  return (
    <Stack
      data-testid={generateTestId('VehicleRecord', 'TransportationDetailsLink')}
      direction="row"
      alignItems="center"
      spacing="0.25rem"
      display="inline-flex"
      onClick={() => scrollTo({ scrollToId })}
    >
      <Typography variant="body2" component="span" color="info.main" sx={{ cursor: 'pointer' }}>
        {label}
      </Typography>
      <InsertLinkIcon
        sx={{
          width: '1rem',
          height: '1rem',
          color: 'info.main',
        }}
      />
    </Stack>
  );
};

LinkToSectionScroll.propTypes = {
  label: PropTypes.string.isRequired,
  scrollToId: PropTypes.string.isRequired,
};

export default LinkToSectionScroll;
